import { z } from 'zod'
import DiagramDataStore from '../models/DiagramDataStore'
import diagramValidator from './diagramValidator'

const diagramDataStoreValidator: z.ZodType<DiagramDataStore> =
  z.record(diagramValidator)

export default diagramDataStoreValidator
